import { gql } from '@apollo/client'
import { BrandFragment } from './brands'
import { CollaborationFragment } from './fragments/collaborations'
import { CreatorFragment } from './fragments/creators'
import { PaginationFragment } from './common'
import { GetRatingsResponse, Pagination, Rating } from './types'

export const RatingFragment = gql`
  fragment RatingFragment on Rating {
    id
    createdAt
    type
    stars
    review
    contentQualityRating
    professionalismRating
    communicationRating
    creativityRating
    timelinessRating
    adherenceToBriefRating
    creator {
      ...CreatorFragment
    }
    brand {
      ...BrandFragment
    }
  }
  ${CreatorFragment}
  ${BrandFragment}
`

export const GET_RATINGS = gql`
  query GetRatings($options: GetRatingsOptions!) {
    getRatings(options: $options) {
      items {
        ...RatingFragment
        creator {
          firstName
          lastName
          avatar {
            url
            name
          }
        }
        brand {
          name
          logo {
            url
            name
          }
        }
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${RatingFragment}
  ${PaginationFragment}
`

export const GET_CREATOR_RATINGS_BY_CREATOR_UUID = gql`
  query GetCreatorRatingsByCreatorUuid(
    $creatorUuid: String!
    $skip: Int
    $limit: Int
  ) {
    getCreatorRatingsByCreatorUuid(
      creatorUuid: $creatorUuid
      skip: $skip
      limit: $limit
    ) {
      items {
        ...RatingFragment
        creator {
          firstName
          lastName
          avatar {
            url
            name
          }
        }
        brand {
          name
          logo {
            url
            name
          }
        }
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${RatingFragment}
  ${PaginationFragment}
`

export const CREATE_RATING = gql`
  mutation CreateRating($input: CreateRatingInput!) {
    createRating(input: $input) {
      id
      createdAt
      stars
      review
      type
      creator {
        ...CreatorFragment
      }
      brand {
        ...BrandFragment
      }
      collaboration {
        ...CollaborationFragment
      }
    }
  }
  ${CreatorFragment}
  ${BrandFragment}
  ${CollaborationFragment}
`

export const UPDATE_RATING = gql`
  mutation UpdateRating($id: Int!, $input: UpdateRatingInput!) {
    updateRating(id: $id, input: $input) {
      ...RatingFragment
    }
  }
  ${RatingFragment}
`

export interface QueryGetCreatorRatingsByCreatorUuid {
  getCreatorRatingsByCreatorUuid: GetRatingsResponse
}
